export default "__VITE_ASSET__CJ47UaYp__"